/**
 * Created by sung on 2017-04-20.
 */
import { NgModule } from '@angular/core';
import {CommonModule} from "@angular/common";
import {DatexPipe} from "./datex.pipe";
import {DeviceDetailValueCheckPipe} from "./deviceDetailValue_nullFormat.pipe";

@NgModule({
    declarations:[DatexPipe,DeviceDetailValueCheckPipe],
    imports:[CommonModule],
    exports:[DatexPipe,DeviceDetailValueCheckPipe]
})

export class MainPipeMoudle{}


// WEBPACK FOOTER //
// ./src/app/pipe/main.pipe.ts